export default __webpack_public_path__ + "static/media/Icon-dark.5229ae13.svg";